<div class="root">
  <mat-icon class="icon"><ng-content select="[icon]"></ng-content></mat-icon>
  <ng-content select="[custom-icon]"></ng-content>
  <div class="text"><ng-content select="[text]"></ng-content></div>
  <crm-actions-row class="toolbar"><ng-content select="[toolbar]"></ng-content></crm-actions-row>
</div>
